import {Link} from '@mui/material';
import {styled} from '@mui/system';
import {
  Stack,
} from '@zoom/react-ui';

export const StyledLink = styled(Link)(({theme}) => ({
  color: theme.palette.text.tertiary,
  display: 'inline-block',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: 'normal',
}));

export const PoweredByContainer = styled(Stack)(({theme}) => ({
  width: '100%',
  height: '16px',
  marginTop: '20px',
}));
